module.exports = __webpack_public_path__ + "static/media/Used Cat Dozers - Toromont Cat.beb1b698.jpg";